import React from 'react'
import { motion } from 'framer-motion'
import ServiceList from '../components/ServiceList'
import servicesData from '../data/services.json'

const ServicesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 dark:bg-custom-dark dark:text-gray-100 transition-colors">

      {/* Hero */}
      <motion.section
        className="pt-28 pb-12 px-4 sm:px-6 lg:px-8 text-center"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="mx-auto max-w-5xl">
          <h1 className="font-display font-bold text-[clamp(2.5rem,6vw,4.5rem)] leading-tight">
            {servicesData.title}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 mt-4">
            {servicesData.subtitle}
          </p>
        </div>
      </motion.section>

      {/* Services List */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="mx-auto max-w-4xl">
          <ServiceList categories={servicesData.categories} />
        </div>
      </section>
    </div>
  )
}

export default ServicesPage
